import { ofType } from "redux-observable";
import { combineLatest, map, retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { TypeActionAuth } from "../../auth/actionAuth";
import { TypeActionPlayerBase } from "../../player-base/actionPlayerBase";
import { actionBaseInfo } from "./actionBaseInfo";
export var epicBaseInfo = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionPlayerBase.SelectBase), combineLatest(action$.ofType(TypeActionAuth.Login)), switchMap(function (actions) {
        return deps.netSend({
            id: CommandCode.FarmInfo,
            props: {
                farmId: actions[0].baseId,
                playerId: actions[1].playerId,
            },
        });
    }), retry(), map(function (res) { return actionBaseInfo(res); }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/base/epicBaseInfo.ts
// module id = 1901
// module chunks = 3